exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "hr[data-v-d876c820]{margin:7px 0}.img-author[data-v-d876c820]{width:30px;height:30px}.input-group[data-v-d876c820]{position:relative}.resultPanel[data-v-d876c820]{z-index:5}.resultPanel ul[data-v-d876c820]{margin-top:10px;margin-bottom:10px}.resultPanel li[data-v-d876c820]{padding:0 20px;margin:0;line-height:34px;cursor:pointer;color:#5a5e66;font-size:14px;list-style:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.resultPanel li[data-v-d876c820]:hover{background-color:#f5f7fa}.panel-enter-active[data-v-d876c820]{transform:translate(0) scaleY(1);transition:all .3s ease}.panel-enter[data-v-d876c820],.panel-leave-active[data-v-d876c820]{transform:translateY(-50%) scaleY(.2);height:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d876c820","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/test/AjaxSearch.vue
// module id = 171
// module chunks = 0